var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNegotiation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3007 2.15625L12.4959 3.96103L9.4853 4.36009C9.16162 4.40298 8.86107 4.55138 8.6302 4.78225L5.76953 7.64291C6.49393 8.3673 7.66839 8.3673 8.39279 7.64291L9.96852 6.06717C9.96852 6.06717 10.1392 7.79152 12.7272 7.70521",
    stroke: "#667085",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6055 7.19531L14.5044 11.0943C14.8342 11.424 14.8265 11.9662 14.4874 12.3054C14.1482 12.6445 13.606 12.6522 13.2763 12.3225L11.4957 10.5419",
    stroke: "#667085",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3549 12.3947C13.6847 12.7244 13.677 13.2666 13.3378 13.6058C12.9987 13.9449 12.4565 13.9526 12.1267 13.6228L10.1758 11.6719",
    stroke: "#667085",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7914 13.2842C12.1211 13.614 12.1134 14.1562 11.7743 14.4953C11.4351 14.8345 10.8929 14.8421 10.5632 14.5124L9.03516 12.9844",
    stroke: "#667085",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3515 14.2995C10.6906 14.6386 10.6906 15.1885 10.3515 15.5277C10.0123 15.8668 9.46243 15.8668 9.12328 15.5277L8.49022 14.8946M5.36128 10.5294L4.55677 11.3339C4.21761 11.6731 3.66774 11.6731 3.32858 11.3339C2.98943 10.9948 2.98943 10.4449 3.32858 10.1058L4.1331 9.30124C4.47225 8.96209 5.02213 8.96209 5.36128 9.30124C5.70043 9.64039 5.70043 10.1903 5.36128 10.5294Z",
    stroke: "#667085",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59175 11.756L5.78724 12.5605C5.44808 12.8997 4.8982 12.8997 4.55905 12.5605C4.2199 12.2213 4.2199 11.6715 4.55905 11.3323L5.36357 10.5278C5.70272 10.1886 6.2526 10.1886 6.59175 10.5278C6.9309 10.867 6.9309 11.4168 6.59175 11.756Z",
    stroke: "#667085",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81831 12.9904L7.0138 13.7949C6.67465 14.134 6.12477 14.134 5.78561 13.7949C5.44646 13.4557 5.44646 12.9058 5.78561 12.5667L6.59013 11.7622C6.92928 11.423 7.47916 11.423 7.81831 11.7622C8.15747 12.1013 8.15747 12.6512 7.81831 12.9904Z",
    stroke: "#667085",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04488 14.2169L8.24036 15.0214C7.90121 15.3606 7.35133 15.3606 7.01218 15.0214C6.67302 14.6823 6.67302 14.1324 7.01218 13.7933L7.81669 12.9887C8.15584 12.6496 8.70572 12.6496 9.04488 12.9887C9.38403 13.3279 9.38403 13.8778 9.04488 14.2169Z",
    stroke: "#667085",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0838 5.17188L14.9834 7.27222L14.3104 9.7501L13.7383 10.3222",
    stroke: "#667085",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33732 4.92591C8.08782 4.67641 7.7494 4.53621 7.39654 4.53621H5.78628L3.95312 2.70312",
    stroke: "#667085",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63329 9.79894V8.30315L0.808594 5.60938",
    stroke: "#667085",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegotiation);
export default __webpack_public_path__ + "static/media/negotiation.5f38ccf99f4ece31a7402138cc9b374a.svg";
export { ForwardRef as ReactComponent };